import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import { Button, Col, Container, Row } from 'react-bootstrap';
import { useParams } from 'react-router-dom';

import { getOutlet } from '../../../apis/queries';
import Loader from '../../../components/Loader';
import Header from '../../../widgets/Header';
import DetailNotFound from '../../DetailNotFound';
import OutletDetailForm from './OutletDetailForm';

const EditOutletButton = ({
  isEditMode,
  isEditFormSubmitting,
  ...props
}: {
  isEditMode: boolean;
  isEditFormSubmitting: boolean;
  onClick: () => void;
}) => {
  return (
    <Button disabled={isEditFormSubmitting} {...props}>
      {' '}
      {isEditMode ? 'View Mode' : 'Edit Mode'}
    </Button>
  );
};

const OutletDetail = () => {
  const { id } = useParams();

  if (!id) {
    return <DetailNotFound />;
  }

  return <OutletDetailContent id={id} />;
};

const OutletDetailContent = ({ id }: { id: string }) => {
  const OUTLET_ID_QUERY_KEY = ['outlets', { id }];
  const { data, isLoading } = useQuery({ queryKey: OUTLET_ID_QUERY_KEY, queryFn: () => getOutlet(id) });
  const [isEditMode, setIsEditMode] = useState(false);
  const [isEditFormSubmitting, setEditFormSubmitting] = useState(false);

  const outlet = data?.data;

  if (isLoading) {
    return <Loader fullscreen />;
  }

  const onEditButtonClicked = () => {
    setIsEditMode(!isEditMode);
  };

  const onEditFormSubmit = (loading: boolean) => {
    setEditFormSubmitting(loading);
  };

  if (!outlet) {
    return <DetailNotFound />;
  }

  return (
    <div className="main-content">
      <Header
        title={outlet?.name}
        isDetailPage
        headerButton={
          <EditOutletButton
            isEditFormSubmitting={isEditFormSubmitting}
            isEditMode={isEditMode}
            onClick={onEditButtonClicked}
          />
        }
      />
      <Container fluid>
        <Row className="justify-content-center">
          <Col xs={12} lg={10} xl={8}>
            <OutletDetailForm
              outlet={outlet}
              isEditMode={isEditMode}
              isEditFormSubmitting={isEditFormSubmitting}
              onEditFormSubmit={onEditFormSubmit}
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default OutletDetail;
